import {
  initSDK,
  sendXspmClick,
  sendXspmScan,
  trackEvent,
  xenv,
  // eslint-disable-next-line prettier/prettier
  utils,
} from '@didi/webx-js'
import apiProxy from '@mpxjs/api-proxy'
import mpx from '@mpxjs/core'
import { getStyle } from '../editor/utils'
import api from '../service'
import store, { pageStyle } from '../store'
import {
  chapter,
  formatPageConfig,
  getEnvParams,
  gotoLink,
  initLogin,
  trackEventLocate,
  // eslint-disable-next-line
  trackEventLogin,
  initLocation,
} from '../utils'
import { HOME_PAGE_SHOW_ENUM, ENTRY_TYPE } from '../constants'

mpx.use(apiProxy, {
  usePromise: true,
})

const mixin = {
  data: {
    couponList: null,
    couponInfo: null,
    activityCouponInfo: null,
    popupResult: null,
    error: '',
    errmsg: '',
    hasCoupon: false,
    hasGetCoupon: false,
    doingGetCoupon: false,
  },
  attached() {
    if (
      this.query.code &&
      this.query.state === window.sessionStorage.getItem('wxOauth')
    ) {
      window.sessionStorage.removeItem('wxOauth')
      this.getCoupon({}, false, false)
    }
  },
  watch: {
    initData: {
      handler(val) {
        // ssg情况下，活动策略数据获取到
        if (!Object.keys(val).length) {
          return
        }
        this.init()
        trackEvent('userteam_fx_home_pg_sw', '展现', {
          status_code: this.error
            ? HOME_PAGE_SHOW_ENUM.error
            : HOME_PAGE_SHOW_ENUM.normal,
          entry_type:
            this.query.dunion_share_channel === 'copy_link'
              ? ENTRY_TYPE.formCopyLink
              : ENTRY_TYPE.else,
        })
        trackEventLocate()
        trackEventLogin()
      },
      immediate: true,
    },
    autoReceiveWatcher: {
      handler(val) {
        // 防止用户主动登陆触发
        if (
          this.hasGetCoupon ||
          this.doingGetCoupon ||
          !val.initData.activity_info
        ) {
          return
        }
        !val.initData.activity_info.has_ecom_coupon &&
          val.initData.activity_info.is_auto_receive &&
          val.token &&
          this.getCoupon()
      },
      immediate: true,
    },
  },
  computed: {
    ...store.mapGetters([
      'query',
      'initData',
      'cityInfo',
      'userInfo',
      'PerfTrack',
    ]),
    warpStyle() {
      return getStyle(this.pageConfig.index.style)
    },
    ruleStyle() {
      return getStyle(this.pageConfig.rule.style)
    },
    btnStyle() {
      return getStyle(this.pageConfig.index.button.style)
    },
    btnText() {
      let text = ''
      if (this.hasGetCoupon && this.hasCoupon) {
        text = this.pageConfig.index.button.gotoText
      } else {
        text = this.pageConfig.index.button.text
      }
      return text
    },
    autoReceiveWatcher() {
      return { initData: this.initData, token: this.userInfo.token }
    },
    curEnv() {
      // 当前环境（ali: 支付宝H5、支付宝小程序，wx: 微信h5、微信小程序，h5: 端内h5、端外h5）
      if (xenv().indexOf('ali') > -1) return 'ali'
      if (xenv().indexOf('wx') > -1 || xenv() === 'weixin') return 'wx'
      return 'h5'
    },
  },
  methods: {
    init() {
      this.error = this.initData.group?.status !== 1 ? 1 : 0
      this.errmsg = this.initData.group?.status_desc
      this.activityCouponInfo =
        this.initData.activity_info?.rewards?.[0]?.coupon
      // 点击按钮后登陆(小程序内嵌h5登陆之后会刷新页面)
      if (__mpx_mode__ === 'web') {
        this.query.is_back === '1' && this.getCoupon({}, false)
      }
      Promise.resolve().then(() => {
        // 为了让 editor/wyc/index.mpx的 attached先执行，给图片赋值
        this.perfTrackImage()
      })
    },
    perfTrackImage() {
      if (__mpx_mode__ === 'web') {
        let mainImage = ''
        if (this.initData.activity_info?.fe_style_version === 'sign_in') {
          mainImage =
            this.pageConfig.signVersion.index.style.backgroundImage.replace(
              /url\('(.*?)'\)/,
              '$1'
            )
        } else {
          mainImage =
            this.pageConfig.header?.image2 ||
            this.pageConfig.header?.image ||
            this.pageConfig.index.style.backgroundImage.replace(
              /url\('(.*?)'\)/,
              '$1'
            )
        }
        this.PerfTrack.coreImageReady({
          immediate: false,
          isKey: false,
          url: mainImage,
        })
        const resources = [mainImage]
        pageStyle[this.info.template]?.couponBg &&
          resources.push(pageStyle[this.info.template].couponBg)
        this.PerfTrack.customTTI({
          immediate: false,
          isKey: false,
          resources: resources,
        })
      }
    },
    // 领券后页面上的 按钮
    toUseCoupon(config, link) {
      // 网约车的b端活动是自动跳转，不需要发
      const xspmInfo = {
        a: '',
        b: this.info.template,
        c: chapter[this.info.template].toUseBtn,
        d: '',
      }
      if (config?.isAuto !== true) {
        trackEvent('userteam_fx_home_bt_ck', '“立即领取”按钮', {
          bt_text: this.btnText,
          action: 'qsy',
        })
        sendXspmClick({}, xspmInfo)
      }
      this.gotoLink(link || this.pageConfig.index, xspmInfo)
    },
    getCoupon: utils.debounce(
      async function (e, showLoading = true, wxOauth) {
        // 花小猪 普通活动和C推活动 点击领券时强拉定位授权
        const { promotion_type } = this.initData?.activity_info || {}
        const { lng, lat } = this.cityInfo || {}

        // 判断是否需要强制定位
        const needForceLocate =
          this.info?.template === 'hxz' &&
          (promotion_type === 'online' || promotion_type === 'personal')

        // 如果需要强制定位且经纬度未定义，则初始化定位
        if (needForceLocate) {
          if (!lng || !lat) {
            await initLocation(false).catch(e => {
              console.error(e)
              mpx.showToast({
                title: '请在手机系统›设置打开定位授权，并刷新重试',
                icon: 'none',
                duration: 3000,
                mask: false,
              })
            })
          }
          // 再次检查经纬度
          if (!this.cityInfo?.lng || !this.cityInfo?.lat) {
            console.error('lng或lat未获取到', this.cityInfo)
            mpx.showToast({
              title: '请在手机系统›设置打开定位授权，并刷新重试',
              icon: 'none',
              duration: 3000,
              mask: false,
            })
            return
          }
        }
        showLoading &&
          trackEvent('userteam_ddlm_coupon_bt_ck', '领券页面-按钮-点击')
        if (this.doingGetCoupon) return
        this.doingGetCoupon = true
        await initLogin({
          needLogin: true,
          wxOauth: wxOauth !== undefined ? wxOauth : this.info.wxOauth,
          redirectParams: {
            is_back: '1',
          },
        }).catch(e => {
          this.doingGetCoupon = false
          throw e
        })
        trackEvent('userteam_fx_home_bt_ck', '立即领取', {
          bt_text: this.btnText,
          action: 'ljlq',
        })
        showLoading &&
          mpx.showLoading({
            mask: true,
          })
        const envInfo = await getEnvParams(e)
        const res = await api.getCoupon({
          env: envInfo,
          pwd_type: this.query.pwd_type,
          exchange_pwd: this.query.exchange_pwd,
          req_env: this.curEnv,
          dunion_callback: this.query.dunion_callback || '',
          xsc: this.query.xsc || '',
        })
        this.doingGetCoupon = false
        showLoading && mpx.hideLoading()
        if (res.errno !== 0) {
          mpx.showToast({
            title: res.errmsg,
            icon: 'none',
            mask: true,
          })
        } else {
          this.popupShow(res.data)
        }
        await this.getRewardList()
        this.hasGetCoupon = true
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].toUseBtn,
            d: '',
          }
        )
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].couponToUseBtn,
            d: '',
          }
        )
      },
      800,
      true
    ),
    async getRewardList() {
      const res = await api.getRewardList()
      if (res.errno !== 0) {
        mpx.showToast({
          title: res.errmsg,
          icon: 'none',
          mask: true,
        })
        return
      }
      if (res.data?.rewards?.length) {
        this.couponList = res.data.rewards
        this.hasCoupon = true
      }
    },
    popupShow(data) {
      this.popupResult = data
      if (__mpx_mode__ === 'web') {
        window.document.body.style.height = '100vh'
        window.document.body.style.overflow = 'hidden'
        window.document.body.style.position = 'relative'
        window.document.documentElement.style.position = 'fixed'
      }
      sendXspmScan(
        {},
        {
          a: '',
          b: this.info.template,
          c: chapter[this.info.template].popupToUseBtn,
          d: '',
        }
      )
    },
    popupClick() {
      trackEvent('userteam_fx_dialog_bt_ck', '“领券弹窗-去使用”按钮')
      console.log('==popupClick===')
      const xspmInfo = {
        a: '',
        b: this.info.template,
        c: chapter[this.info.template].popupToUseBtn,
        d: '',
      }
      sendXspmClick({}, xspmInfo)
      let link = this.pageConfig.index.link
      if (xenv().indexOf('ali') > -1 && this.pageConfig.index.alipay_link) {
        link = this.pageConfig.index.alipay_link
      }
      this.gotoLink(link, xspmInfo)
    },
    popupClose() {
      setTimeout(() => {
        this.popupResult = null
      }, 100)
      if (__mpx_mode__ === 'web') {
        window.document.body.style.height = '100%'
        window.document.body.style.overflow = 'auto'
        window.document.documentElement.style.position = 'static'
      }
    },
    // 单个券
    couponToUse(e) {
      const item = e.detail.item
      const batch_id = item.coupon?.batch_id
      trackEvent('userteam_fx_home_couponlist_re_ck', '券-去使用按钮', {
        batch_id: batch_id,
        bt_txt: item.coupon_txt,
      })
      const xspmInfo = {
        a: '',
        b: this.info.template,
        c: chapter[this.info.template].couponToUseBtn,
        d: '',
      }
      sendXspmClick({}, xspmInfo)
      this.gotoLink(item, xspmInfo)
    },
    gotoLink,
  },
}

console.log('========coupon-mixin11111111===== ', process.env.MODE)
if (process.env.MODE === 'editor') {
  console.log('========coupon-mixin222======= ')
  mixin.attached = function () {
    // xpub编辑器用
    console.log('=======coupon-mixin3333333attached===== ')
    initSDK({ branch: 'passenger' })
    const res = require('../../editor/fenxiaoNy/model/props').mockIndex
    this.activityCouponInfo = res.data?.activity_info?.rewards?.[0]?.coupon
    this.couponInfo =
      res.data?.rewards?.[0]?.coupon ||
      res.data?.activity_info?.rewards?.[0]?.coupon
    this.couponInfo.tip = '最高'
    store.commit('setInitData', res.data)
    this.$watch('pageConfig', {
      handler: function (val) {
        formatPageConfig(this.pageConfig, this.info.template)
        if (['zc', 'gift'].includes(this.info.template)) {
          this.couponList = res.data.rewards
        }
        // wyc逻辑
        if (this.info.template === 'wyc') {
          if (this.pageConfig.result?.show || this.pageConfig.resultB?.show) {
            this.couponList = res.data.rewards
          }
          if (this.pageConfig.index.show) {
            if (this.pageConfig.friday.mockEnable) {
              this.style = this.pageConfig.friday.style
              this.redPacketConfig.style =
                this.pageConfig.friday.redPacket.style
            } else {
              this.formatPageConfig && this.formatPageConfig()
            }
          } else if (this.pageConfig.launchApp.index.show) {
            if (this.pageConfig.launchApp.friday.mockEnable) {
              this.style = this.pageConfig.launchApp.friday.style
            } else {
              this.formatPageConfig && this.formatPageConfig()
              const bg =
                this.pageConfig.launchApp.index.style.backgroundImage ||
                this.style.backgroundImage
              this.style = Object.assign(
                this.pageConfig.launchApp.index.style,
                { backgroundImage: bg }
              )
            }
          }
        }
      },
      immediate: true,
      deep: true,
    })

    this.$watch('pageConfig.popup.showMock', function (val) {
      this.popupResult = val ? res.data : null
    })
  }

  // watch一个store中computed变量，在xpub侧会失效
  delete mixin.watch
}

export default mixin
